/* ---------------------------------------------------------------------------------------------------------------
   KOPSTORM BUY BOX (ONYX)

   The buy box itself is rendered server side, including every price and every state. This script only:
     1. flips one attribute when the shopper switches option (CSS does the rest, so there is no flicker)
     2. remembers the chosen option and colours across the theme's server side product re-render
     3. intercepts the product form submit and posts all bundle line items in a single /cart/add.js call
     4. keeps bundle groups intact in the cart (removing the suitcase removes its bundled accessories)

   The price discount itself is applied by an automatic Buy X Get Y discount in Shopify admin, never here.
--------------------------------------------------------------------------------------------------------------- */

(function () {
  'use strict';

  var BUNDLE_KEY = '_kop_bundle';
  var PARENT_KEY = '_kop_bundle_parent';
  var STORE_PREFIX = 'kop-buybox:';
  var OPTIONS = ['single', 'bundle', 'bundle2'];

  /* ------------------------------------------------------------------ helpers */

  function root() {
    return document.documentElement;
  }

  function isActive(box) {
    if (!box) return false;
    if (box.getAttribute('data-kop-test') !== '1') return true;
    return root().getAttribute('data-kop-buybox') === 'on' || document.body.classList.contains('kop-buybox-on');
  }

  function boxes() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-kop-buybox]'));
  }

  function activeBoxForForm(formId) {
    var found = null;
    boxes().forEach(function (box) {
      if (found) return;
      if (box.getAttribute('data-form') === formId && isActive(box)) found = box;
    });
    return found;
  }

  function readState(box) {
    try {
      var raw = window.sessionStorage.getItem(STORE_PREFIX + box.getAttribute('data-block'));
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function writeState(box) {
    try {
      var colors = {};
      box.querySelectorAll('[data-kop-acc]').forEach(function (row) {
        var checked = row.querySelector('[data-kop-color]:checked');
        if (checked) colors[row.getAttribute('data-kop-acc')] = checked.value;
      });

      window.sessionStorage.setItem(
        STORE_PREFIX + box.getAttribute('data-block'),
        JSON.stringify({ option: box.getAttribute('data-selected'), colors: colors })
      );
    } catch (error) {
      /* storage unavailable, state simply is not remembered */
    }
  }

  /* ------------------------------------------------------------------ state */

  function syncRoot() {
    var bundleActive = false;

    boxes().forEach(function (box) {
      if (isActive(box) && box.getAttribute('data-selected') !== 'single') bundleActive = true;
      if (
        isActive(box) &&
        box.getAttribute('data-kop-manage-klarna') === '1' &&
        !document.body.classList.contains('kop-buybox-managed-klarna')
      ) {
        document.body.classList.add('kop-buybox-managed-klarna');
      }
    });

    if (bundleActive) {
      root().setAttribute('data-kop-bundle', '1');
    } else {
      root().removeAttribute('data-kop-bundle');
    }
  }

  /* 8 Oct 2026: the price block at the top of the product page stayed on the suitcase price when the shopper picked
     Koffer compleet. Each option carries its own price strings (rendered in Liquid in the same format as
     snippets/price-list.liquid), and the top price, compare price and BESPAAR badge follow the selected option. A colour
     change re-renders the price block and the buy box, and restore() runs this again on the fresh markup. */
  function setPriceText(element, text) {
    var label = element.querySelector('.sr-only');
    element.textContent = '';
    if (label) element.appendChild(label);
    element.appendChild(document.createTextNode(text));
  }

  /* 19 Oct 2026 (EcomTraffic): the BESPAAR prefix can be overridden in Theme settings > ET - Campaign > Savings badge
     prefix. The option strings are built with the general.kopstorm.save translation, so the translated label is swapped
     for the prefix that snippets/price-list.liquid puts on the price list (data-et-save-prefix / data-et-save-label,
     only present while that setting is filled). */
  function savingsText(list, text) {
    var prefix = list.getAttribute('data-et-save-prefix');
    var label = list.getAttribute('data-et-save-label');
    if (!text || !prefix || !label || prefix === label || text.indexOf(label) !== 0) return text;
    return prefix + text.slice(label.length);
  }

  function syncMainPrice(box) {
    if (!isActive(box)) return;

    var option = box.querySelector('[data-kop-option="' + box.getAttribute('data-selected') + '"]');
    if (!option || !option.hasAttribute('data-kop-main-price')) return;

    var scope = box.closest('.product-info') || document;
    var block = scope.querySelector('.product-info__price');
    if (!block) return;

    var list = block.querySelector('price-list');
    if (!list) return;

    var price = option.getAttribute('data-kop-main-price');
    var compare = option.getAttribute('data-kop-main-compare');
    var save = savingsText(list, option.getAttribute('data-kop-main-save'));

    var sale = list.querySelector('sale-price');
    if (sale) {
      setPriceText(sale, price);
    }

    var compareEl = list.querySelector('compare-at-price');
    if (compare) {
      if (!compareEl) {
        compareEl = document.createElement('compare-at-price');
        compareEl.className = 'text-subdued line-through';
        var label = document.createElement('span');
        label.className = 'sr-only';
        compareEl.appendChild(label);
        if (sale && sale.nextSibling) {
          list.insertBefore(compareEl, sale.nextSibling);
        } else {
          list.appendChild(compareEl);
        }
      }
      setPriceText(compareEl, compare);
      compareEl.hidden = false;
    } else if (compareEl) {
      compareEl.hidden = true;
    }

    var badge = block.querySelector('.discount_badge');
    if (save) {
      if (!badge) {
        badge = document.createElement('p');
        badge.className = 'discount_badge';
        list.insertAdjacentElement('afterend', badge);
      }
      badge.textContent = save;
      badge.style.display = '';
    } else if (badge) {
      badge.style.display = 'none';
    }
  }

  function selectOption(box, value) {
    if (box.getAttribute('data-selected') !== value) box.setAttribute('data-selected', value);

    var input = box.querySelector('[data-kop-option-input][value="' + value + '"]');
    if (input && !input.checked) input.checked = true;

    syncRoot();
    syncMainPrice(box);
    writeState(box);
  }

  function syncMedia(row) {
    var checked = row.querySelector('[data-kop-color]:checked');
    if (!checked) return;

    var images = row.querySelectorAll('[data-kop-media]');
    if (!images.length) return;

    Array.prototype.forEach.call(images, function (image) {
      var match = image.getAttribute('data-kop-media') === checked.value;
      if (match === image.hasAttribute('hidden')) {
        if (match) {
          image.removeAttribute('hidden');
        } else {
          image.setAttribute('hidden', '');
        }
      }
    });
  }

  function syncAllMedia(box) {
    Array.prototype.forEach.call(box.querySelectorAll('[data-kop-acc]'), syncMedia);
  }

  function restore(box) {
    if (box.getAttribute('data-kop-ready') === '1') return;
    box.setAttribute('data-kop-ready', '1');

    var state = readState(box);

    if (state && state.colors) {
      Object.keys(state.colors).forEach(function (index) {
        var row = box.querySelector('[data-kop-acc="' + index + '"]');
        if (!row) return;
        var input = row.querySelector('[data-kop-color][value="' + state.colors[index] + '"]');
        if (input) input.checked = true;
      });
    }

    syncAllMedia(box);

    if (state && OPTIONS.indexOf(state.option) !== -1) {
      selectOption(box, state.option);
    } else {
      syncRoot();
      syncMainPrice(box);
    }
  }

  function restoreAll() {
    boxes().forEach(restore);
    syncRoot();
  }

  /* ------------------------------------------------------------------ cart payload */

  function selectedLines(box) {
    var lines = [];
    var selected = box.getAttribute('data-selected');

    /* Each offer has its own rows, so only the rows inside the selected option may be added to the cart. */
    var option = box.querySelector('[data-kop-option="' + selected + '"]');
    if (!option) return lines;

    Array.prototype.forEach.call(option.querySelectorAll('[data-kop-acc]'), function (row) {
      var checked = row.querySelector('[data-kop-color]:checked') || row.querySelector('[data-kop-color-fixed]');
      if (!checked || !checked.value) return;

      var quantity = parseInt(row.getAttribute('data-kop-qty'), 10);
      if (!quantity || quantity < 1) quantity = 1;

      lines.push({ id: checked.value, quantity: quantity });
    });

    return lines;
  }

  function formProperties(form) {
    var properties = {};

    Array.prototype.slice.call(form.elements).forEach(function (element) {
      if (!element.name) return;
      if (element.name.indexOf('properties[') !== 0) return;
      if (element.type === 'checkbox' && !element.checked) return;
      if (!element.value) return;

      var name = element.name.slice('properties['.length, -1);
      properties[name] = element.value;
    });

    return properties;
  }

  function mainVariantId(form, box) {
    var input = form.querySelector('[name="id"]:not([disabled])') || form.querySelector('[name="id"]');
    if (input && input.value) return input.value;
    return box.getAttribute('data-variant');
  }

  function busy(form, state) {
    Array.prototype.slice.call(form.elements)
      .filter(function (element) {
        return element.type === 'submit';
      })
      .forEach(function (button) {
        if (state) {
          button.setAttribute('aria-busy', 'true');
        } else {
          button.removeAttribute('aria-busy');
        }
      });
  }

  function bundleId() {
    return 'kop-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  async function addBundle(form, box) {
    var parentId = mainVariantId(form, box);
    var accessoryLines = selectedLines(box);
    var groupId = bundleId();
    var base = formProperties(form);

    var mainProperties = Object.assign({}, base);
    mainProperties[BUNDLE_KEY] = groupId;

    var items = [{ id: parentId, quantity: 1, properties: mainProperties }];

    accessoryLines.forEach(function (line) {
      var properties = {};
      properties[BUNDLE_KEY] = groupId;
      properties[PARENT_KEY] = String(parentId);
      items.push({ id: line.id, quantity: line.quantity, properties: properties });
    });

    busy(form, true);

    try {
      var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      });

      var payload = await response.json();

      if (!response.ok) {
        form.dispatchEvent(
          new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: payload.description || payload.message }
          })
        );
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      var cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();

      form.dispatchEvent(
        new CustomEvent('variant:add', { bubbles: true, detail: { items: payload.items || [payload], cart: cart } })
      );

      root().dispatchEvent(
        new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } })
      );

      document.dispatchEvent(new CustomEvent('cart:refresh'));

      if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page') {
        window.location.href = window.Shopify.routes.root + 'cart';
        return;
      }

      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') {
        drawer.show();
      } else {
        window.location.href = window.Shopify.routes.root + 'cart';
      }
    } catch (error) {
      form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: String(error) } }));
    } finally {
      busy(form, false);
    }
  }

  /* ------------------------------------------------------------------ bundle integrity in the cart */

  var cleaning = false;

  async function removeOrphans(cart) {
    if (cleaning || !cart || !cart.items) return;

    var parents = {};
    cart.items.forEach(function (item) {
      var properties = item.properties || {};
      if (properties[BUNDLE_KEY] && !properties[PARENT_KEY]) parents[properties[BUNDLE_KEY]] = true;
    });

    var updates = {};
    var orphaned = false;

    cart.items.forEach(function (item) {
      var properties = item.properties || {};
      if (properties[BUNDLE_KEY] && properties[PARENT_KEY] && !parents[properties[BUNDLE_KEY]]) {
        updates[item.key] = 0;
        orphaned = true;
      }
    });

    if (!orphaned) return;

    cleaning = true;

    try {
      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: updates })
      });

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      /* leave the cart untouched when the cleanup call fails */
    } finally {
      cleaning = false;
    }
  }

  /* ------------------------------------------------------------------ listeners */

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var box = target.closest('[data-kop-buybox]');
    if (!box) return;

    if (target.hasAttribute('data-kop-option-input')) {
      selectOption(box, target.value);
      return;
    }

    if (target.hasAttribute('data-kop-color')) {
      var row = target.closest('[data-kop-acc]');
      if (row) syncMedia(row);

      var option = target.closest('[data-kop-option]');
      if (option) selectOption(box, option.getAttribute('data-kop-option'));
    }
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var option = target.closest('[data-kop-option]');
    if (!option) return;

    /* clicks on a colour swatch belong to that swatch, not to the card */
    if (target.closest('.kop-buybox__swatches')) return;

    var box = option.closest('[data-kop-buybox]');
    if (!box) return;

    selectOption(box, option.getAttribute('data-kop-option'));
  });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;

      /* NEVER read form.id here. The product form contains an input named "id", and a named form control
         shadows the element's own id property, so form.id returns that input element instead of the string.
         The theme relies on the same shadowing in its ProductForm (this.id.disabled = false). */
      var formId = form.getAttribute('id');
      if (!formId) return;

      var box = activeBoxForForm(formId);
      if (!box || box.getAttribute('data-selected') === 'single') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      addBundle(form, box);
    },
    true
  );

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.cart) removeOrphans(event.detail.cart);
  });

  /* The theme re-renders product info server side on every variant change, which replaces the buy box markup.
     Watch for a fresh, not yet initialised buy box and restore the shopper's choices onto it. */
  var scheduled = false;

  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      if (document.querySelector('[data-kop-buybox]:not([data-kop-ready])')) restoreAll();
    });
  });

  /* 29 Sep 2026: a colour change on the same product is a PARTIAL re-render in the theme, which only swaps a fixed list
     of block types (price, inventory, buy-buttons and so on). The buy box is not on that list, so it kept the prices
     and variant name of the variant the page loaded with (Onyx Black on sale while Desert Clay was selected). The
     theme dispatches a non bubbling product:rerender on the form, so listen in the capture phase and swap every buy
     box block of that form for its freshly rendered version. A product change replaces the whole info block already. */
  function deepFind(rootNode, selector) {
    var found = rootNode.querySelector(selector);
    if (found) return found;
    var templates = rootNode.querySelectorAll('template');
    for (var i = 0; i < templates.length; i++) {
      found = deepFind(templates[i].content, selector);
      if (found) return found;
    }
    return null;
  }

  document.addEventListener('product:rerender', function (event) {
    var detail = event.detail || {};
    var form = event.target;
    /* 8 Oct 2026: read the id attribute. form.id is the shadowing "id" input (see the submit handler), so the old
       comparison never matched and the buy box kept the prices of the variant the page loaded with. */
    var formId = form && form.getAttribute ? form.getAttribute('id') : '';
    if (!detail.htmlFragment || detail.productChange || !formId) return;

    boxes().forEach(function (box) {
      if (box.getAttribute('data-form') !== formId) return;
      var wrapper = box.closest('[data-block-type="kopstorm-buybox"][data-block-id]');
      if (!wrapper) return;
      var fresh = deepFind(
        detail.htmlFragment,
        '[data-block-type="kopstorm-buybox"][data-block-id="' + wrapper.getAttribute('data-block-id') + '"]'
      );
      if (!fresh) return;
      Array.prototype.forEach.call(fresh.querySelectorAll('noscript'), function (node) { node.remove(); });
      wrapper.replaceWith(fresh.cloneNode(true));
    });

    /* the theme swaps the price block back to the variant price in the same re-render, so sync it once that is done */
    window.requestAnimationFrame(function () {
      boxes().forEach(syncMainPrice);
    });
  }, true);

  /* Intelligems switches the test variant on after page load by setting an attribute or a class, so the buy box has
     to react to that too, not only to its own state changes. */
  var activationObserver = new MutationObserver(function () {
    syncRoot();
    boxes().forEach(syncMainPrice);
  });

  function start() {
    restoreAll();
    observer.observe(document.body, { childList: true, subtree: true });
    activationObserver.observe(root(), { attributes: true, attributeFilter: ['data-kop-buybox'] });
    activationObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
